import { BaseFieldConfig } from "../../../CommonElements/DynamicFieldRenderer";

export const menuFormFields: BaseFieldConfig[] = [
  {
    name: "name",
    label: "Menu Name",
    type: "text",
    col: 6,
  },
  {
    name: "route",
    label: "Route",
    type: "text",
    col: 6,
  },
  {
    name: "icon",
    label: "Icon",
    type: "text",
    col: 6,
  },
  {
    name: "parent_id",
    label: "Parent Menu",
    type: "select",
    col: 6,
    dynamicOptions: "menuOptions",
  },
  {
    name: "sort_order",
    label: "Sort Order",
    type: "number",
    col: 6,
  },
  {
    name: "is_default",
    label: "Default",
    type: "select",
    col: 6,
    options: [
      { label: "Yes", value: "1" },
      { label: "No", value: "0" },
    ],
  },
  {
    name: "status",
    label: "Status",
    type: "select",
    col: 6,
    options: [
      { label: "Active", value: "1" },
      { label: "Inactive", value: "0" },
    ],
  },
];
